import { FlexRow, FullContainer, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { useSetRecoilState } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { updateReportsState } from '../../storage/reports';
import { StyledTooltip } from '../ui/StyledTooltip';
import { PathsDownloadList } from './PathsDownloadList';

export function PathsDownloadsTab() {
  const { css, theme, classes } = useStyles();
  const setUpdateReports = useSetRecoilState(updateReportsState);

  return (
    <FullContainer
      verticalFlex
      classNames={`${css({
        padding: theme.sizing.scale500,
        boxSizing: 'border-box',
      })}`}
      gap={theme.sizing.scale500}
    >
      <FlexRow classNames={classes.centeredEnd}>
        <StyledTooltip
          content={'Recargar tabla'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={() => setUpdateReports((prev) => !prev)}
            kind="tertiary"
          >
            <MaterialIcon name={'refresh'} />
          </Button>
        </StyledTooltip>
      </FlexRow>
      <PathsDownloadList />
    </FullContainer>
  );
}
